import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import LoginContext from '../../context'

const SidebarListBox = ({ listItems }) => {
    const { openLoginPopup, isAuthenticated } = useContext(LoginContext)
    const navigate = useNavigate()

    // const handleLoginPopup = (e, acces_after_login, link_src) => {
    //     // const handleLoginPopup = (e, link_src) => {
    //     if (link_src === "#" && !link_src.includes('/') && !isAuthenticated && acces_after_login) {
    //         e.preventDefault()
    //         openLoginPopup()
    //     }
    //     else{
    //         navigate(link_src)
    //     }
    //     // if (acces_after_login && !isAuthenticated) {
    //     //     e.preventDefault()
    //     //     openLoginPopup()
    //     // }
    //     // else {
    //     //     navigate(link_src)
    //     // }
    // }


    const handleLoginPopup = (e, link_src) => {
        const protectedRoutes = ['/message', '/coupon', '/recommend_list', '/customer', '/notice', '/cash_1', '/cash_2', '/betting', '/result', '/event', '/message', '/']

        const isProtectedRoute = protectedRoutes.some(route => link_src.includes(route))

        if (!isAuthenticated && isProtectedRoute) {
            e.preventDefault()
            openLoginPopup()
        } else {
            navigate(link_src)
        }
    }

    return (
        <>

            <ul className='mx-[25px] mt-5 p-2.5 ps-5 border border-slate w-[250px] text-sm bg-[#2c2c2c] rounded-[10px]'>
                {listItems.map((item, index) => (
                    (isAuthenticated || !item.show_after_login) && (
                        <li className=' border-b border-slate m-0 font-NotoSansKR' key={index}>
                            <Link to={item.link_src} className='block ml-0 text-base font-thin mt-0 h-[43px] leading-[43px] text-left hover:text-aquaBlue transition-all duration-300 ease-in-out'
                                // onClick={(e) => handleLoginPopup(e, item.link_src)}>
                                // onClick={(e) => handleLoginPopup(e, item.acces_after_login, item.link_src)}
                                onClick={(e) => handleLoginPopup(e, item.link_src)}
                            >
                                <i className={`${isAuthenticated && item.login_icon_name ? item.login_icon_name : item.icon_name} text-[22px] mr-[5px] gradient-with-animation bg-[length:30rem_30rem] align-middle`}></i>  {item.link_name}
                            </Link>
                        </li>
                    )
                ))}
            </ul>
        </>
    )
}

export default SidebarListBox